module.exports = __webpack_public_path__ + "img/Comment_ca_marche_2.fc38822b.webp";